module.exports = new __parcel__URL__("eye-off.e08a48fa.svg").toString();